import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '../shared/shared.module';
import { TranslateModule } from 'ng2-translate';

import { ChartsModule } from 'ng2-charts';

import { RouteDetailComponent } from './route-detail.component';
import { HeatmapComponent } from './components/heatmap/heatmap.component';
import { RouteDetailService } from './services/route-detail.service';
import { LinegraphComponent } from './components/linegraph/linegraph.component';
import { RouteInfoComponent } from './components/route-info/route-info.component';

import { LinegraphApiService } from '../domain/services/linegraph/linegraph.api.service';
import { LinegraphDomainService } from '../domain/services/linegraph/linegraph.domain.service';
import { HistogramComponent } from './components/histogram/histogram.component';
import { SliderModule } from 'primeng/primeng';
import { DaySelectorComponent } from './components/day-selector/day-selector.component';
import { RouteInfoItemComponent } from './components/route-info/components/route-info-item/route-info-item.component';
import { RouteSelectorComponent } from './components/route-selector/route-selector/route-selector.component';
import { AllRoutesSelectorComponent } from './components/all-routes-selector/all-routes-selector.component';
import { BranchingApiService } from './components/branching-container/services/branching.api.service';
import { BranchingDomainService } from './components/branching-container/services/branching.domain.service';
import { BranchingContainersComponent } from './components/branching-container/branching-containers.component';
import { BranchFiltersComponent } from './components/branching-container/components/branch-filter/branch-filters.component';
import { BranchInfoComponent } from './components/branching-container/components/branch-info/branch-info.component';



@NgModule({
  imports: [
    SliderModule,
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    ChartsModule,
    TranslateModule.forRoot()
  ],
  exports: [
    RouteDetailComponent,
    HeatmapComponent,
    LinegraphComponent,
    RouteInfoComponent,
    DaySelectorComponent,
    BranchFiltersComponent
  ],
  providers: [RouteDetailService, LinegraphApiService, LinegraphDomainService, BranchingApiService, BranchingDomainService],
  declarations: [RouteDetailComponent, HeatmapComponent, LinegraphComponent, RouteInfoComponent, HistogramComponent, DaySelectorComponent, RouteInfoItemComponent, RouteSelectorComponent, AllRoutesSelectorComponent, BranchInfoComponent, BranchingContainersComponent, BranchFiltersComponent]
})
export class RouteDetailModule { }



// WEBPACK FOOTER //
// ./src/app/modules/route-detail/route-detail.module.ts